/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import {
    BWHListType,
    THorizontalItem,
    TScrollDirection,
    TVerticalItems,
} from './biaxialwidget.props';
import {
    BIAXIAL_WIDGET_CLEAR_DATA,
    BIAXIAL_WIDGET_UPDATE_CARET_VISIBLE,
    BIAXIAL_WIDGET_UPDATE_HORIZONTAL_ITEMS,
    BIAXIAL_WIDGET_UPDATE_HORIZONTAL_POSITION,
    BIAXIAL_WIDGET_UPDATE_TURBO_SCROLL,
    BIAXIAL_WIDGET_UPDATE_VERTICAL_ITEMS,
    BIAXIAL_WIDGET_UPDATE_VERTICAL_POSITION,
} from './biaxialwidget.types';

export const biaxialWidgetClearDataAction = () => ({
    type: BIAXIAL_WIDGET_CLEAR_DATA,
    payload: {
        turboScrollDirection: null,
        horizontalItem: {
            listType: BWHListType.DEFAULT,
            listItems: [],
            isEmpty: false,
        },
        horizontalPosition: 0,
        isCaretVisible: false,
        isTurboScroll: false,
        verticalItems: [],
        verticalPosition: 0,
    },
});

export const biaxialWidgetUpdateCaretVisibleAction = (isCaretVisible: boolean) => ({
    type: BIAXIAL_WIDGET_UPDATE_CARET_VISIBLE,
    payload: { isCaretVisible },
});

export const biaxialWidgetUpdateHorizontalItemsAction = (horizontalItem: THorizontalItem) => ({
    type: BIAXIAL_WIDGET_UPDATE_HORIZONTAL_ITEMS,
    payload: { horizontalItem },
});

export const biaxialWidgetUpdateHorizontalPositionAction = (horizontalPosition: number) => ({
    type: BIAXIAL_WIDGET_UPDATE_HORIZONTAL_POSITION,
    payload: { horizontalPosition },
});

export const biaxialWidgetUpdateTurboScrollAction = (
    isTurboScroll: boolean,
    turboScrollDirection: TScrollDirection | null,
) => ({
    type: BIAXIAL_WIDGET_UPDATE_TURBO_SCROLL,
    payload: { isTurboScroll, turboScrollDirection },
});

export const biaxialWidgetUpdateVerticalItemsAction = (verticalItems: TVerticalItems) => ({
    type: BIAXIAL_WIDGET_UPDATE_VERTICAL_ITEMS,
    payload: { verticalItems },
});

export const biaxialWidgetUpdateVerticalPositionAction = (verticalPosition: number) => ({
    type: BIAXIAL_WIDGET_UPDATE_VERTICAL_POSITION,
    payload: { verticalPosition },
});
